module.exports = __webpack_public_path__ + "static/media/view2.4e6a836d.jpg";